export const GET_DMX_DEVICE_PRESET_BY_ID = 'GET_DMX_DEVICE_PRESET_BY_ID';
export const GET_DMX_DEVICE_PRESET_BY_ID_SUCCESS = 'GET_DMX_DEVICE_PRESET_BY_ID_SUCCESS';
export const GET_DMX_DEVICE_PRESET_BY_ID_ERROR = 'GET_DMX_DEVICE_PRESET_BY_ID_ERROR';
